<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.deleted') }}</label></td>
      <td><span v-if="details.deleted_at">{{ details.deleted_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.confirmed_at') }}</label></td>
      <td><span v-if="details.confirmed_at">{{ details.confirmed_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.activation_starts_at') }}</label></td>
      <td><span v-if="details.activation_starts_at">{{ details.activation_starts_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.activation_ends_at') }}</label></td>
      <td><span v-if="details.activation_ends_at">{{ details.activation_ends_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.canceled_at') }}</label></td>
      <td><span v-if="details.canceled_at">{{ details.canceled_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.cancel_description') }}</label></td>
      <td>
        <description-or-link v-if="details.cancel_description" :description="details.cancel_description"/>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.accountID') }}</label></td>
      <td>
        <router-link :to="{name: 'account-profile', params: {id: details.account_id}}">
          {{ details.account_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.discountID') }}</label></td>
      <td>{{ details.discount_id }}</td>
    </tr>
    <tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.fare_group_id') }}</label></td>
      <td>
        {{ details.fare_group_id }}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.season_ticket_id') }}</label></td>
      <td>
        {{ details.season_ticket_id }}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.season_ticket_revision_id') }}</label></td>
      <td>
          {{ details.season_ticket_revision_id }}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.price') }}</label></td>
      <td>{{ details.price | money }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.payment_type') }}</label></td>
      <td>{{ details.payment_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.distributors_company_name') }}</label></td>
      <td>{{ details.distributors_company_name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.merchant_reference') }}</label></td>
      <td>{{ details.merchant_reference }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountSeasonTickets.details.origin') }}</label></td>
      <td>{{ details.origin }}</td>
    </tr>

    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>

    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
  </table>
</template>
<script>
import DescriptionOrLink from "src/components/Description/DescriptionOrLink"

export default {
  name: 'AccountSeasonTicketDetails',
  components: {
    DescriptionOrLink
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
